import { useEffect, useState, useRef } from "react";
import { List, ListItem, ListItemText, Fab, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import formatDate from "../../../utilities/formatDate";

import Editor from "./Editor";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Messages = () => {
  const editorRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getMessages();
  }, []);

  const getMessages = async () => {
    const result = await request("systemmessage");
    if (result.success) {
      setMessages(result.data);
    }
  };

  const handleClick = async (message) => {
    const result = await request(`systemmessage/?id=${message._id}`);
    if (result.success) {
      setSelectedMessage(result.data);
      setOpen(true);
    } else {
      toast.error(result.error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMessage(null);
  };

  const handleSave = async (data) => {
    console.log(data);
    let result;
    if (data.create) {
      result = await request("systemmessage/create", "post", data);
    } else {
      result = await request(
        `systemmessage/update/${selectedMessage._id}`,
        "post",
        data
      );
    }

    if (result.success) {
      toast.success("Success!");
      handleClose();
      getMessages();
      //GET updated list
    } else {
      toast.error(result.error);
    }
  };

  return (
    <>
      <List>
        {messages.map((msg) => (
          <ListItem key={msg._id} onClick={() => handleClick(msg)}>
            <Paper elevation={3} style={{width: 500, padding: 10, cursor: 'pointer'}}>
              <ListItemText primary={msg.title} />
               <ListItemText secondary={formatDate(msg.createdAt)} />
            </Paper>
          </ListItem>
        ))}
      </List>
      <Editor
        open={open}
        close={handleClose}
        selectedMessage={selectedMessage}
        editorRef={editorRef}
        save={handleSave}
      />
      <Fab
        size="small"
        color="primary"
        style={{ position: "absolute", bottom: 10, right: 10 }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <AddIcon />
      </Fab>
    </>
  );
};

export default Messages;
